module.exports = __webpack_public_path__ + "static/img/img_form2_zh.55ee66af.png";